import { UserAction, UserActions } from '../actions/user.actions';
import { UserRolesState } from '../state/user.state';

export const initialUserRolesState: UserRolesState = {
    roles: {},
};

export function userInfoReducer(
    state = initialUserRolesState,
    action: UserAction
) {
    switch (action.type) {
        case UserActions.GetUserRoles:
            return {
                roles: action.payload,
            };
        default:
            return state;
    }
}
